import React from "react"
import {useTranslation} from "react-i18next"

import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import { Send as SendIcon } from '@vedmarket/ui-kit'

import {COLORS} from "../../../../../config/constants"
import Emoji from "../emoji"
import AccountAction from "../account-action"
import { formatDemoCopy } from '../hero/helpers'
import './footer.scss'

const Footer = ({ accountActionUrl, isRegistered, isDesktop }: DemoAccountProps) => {

  const { t } = useTranslation()

  return (
    <Paper
      className={isDesktop ? 'demo-footer demo-footer_desktop' : 'demo-footer'}
      elevation={0}
      sx={{
        borderRadius: 0,
        backgroundColor: isDesktop ? 'transparent' : COLORS.BLUE,
        boxShadow: isDesktop ? "none" : `
          0 11px 15px -7px rgba(0, 0, 0, 0.20),
          0 24px 38px 3px rgba(0, 0, 0, 0.14),
          0 9px 46px 8px rgba(0, 0, 0, 0.12)
        `,
      }}
    >
      <div className='demo-footer__text'>
        <div className='demo-footer__message'>
          <Typography
            component='div'
            className='demo-footer__icon'
            sx={{
              fontSize: isDesktop ? '64px' : '24px',
              width: isDesktop ? 64 : undefined,
              fontWeight: 400,
              lineHeight: isDesktop ? '64px' : '24px',
              color: COLORS.YELLOW,
              ...(isDesktop && {
                '@media (min-width: 768px) and (max-width: 1199px)': {
                  fontSize: 56,
                  lineHeight: '56px',
                  width: 56
                },
                '@media (max-width: 767px)': {
                  fontSize: 48,
                  lineHeight: '48px',
                  width: 48
                },
              }),
            }}
          >
            <Emoji
              className='demo__emoji'
              label={t('calc__text__demoMarqueeTitle')}
              symbol={isDesktop ? '🚀' : '⚡'}
            />
          </Typography>
          <Typography
            variant='h6'
            className='demo-footer__title'
            sx={{
              fontFamily: isDesktop ? 'Nexa ExtraBold, sans-serif' : undefined,
              fontSize: isDesktop ? '28px' : undefined,
              fontWeight: isDesktop ? 800 : undefined,
              lineHeight: isDesktop ? '1.3' : '28px',
              letterSpacing: '0',
              color: COLORS.WHITE,
              ...(isDesktop && {
                '@media (min-width: 768px) and (max-width: 1199px)': {
                  fontSize: 24
                },
                '@media (max-width: 767px)': {
                  fontSize: 20
                },
              }),
            }}
          >
            {formatDemoCopy(t(isRegistered ? 'calc__text__demoFooterCabinetTitle' : 'calc__text__demoFooterTitle'))}
          </Typography>
        </div>
        {isDesktop ? <AccountAction accountActionUrl={accountActionUrl} isRegistered={isRegistered} /> : <Button
          data-demo-allowed='registration'
          className='demo-footer__button'
          variant='contained'
          href={accountActionUrl}
          target='_blank'
          rel='noreferrer'
          startIcon={<SendIcon className='demo-footer__button-icon' />}
          sx={{
            width: '360px',
            height: '40px',
            color: COLORS.BLACK_DARK,
            backgroundColor: COLORS.WHITE,
            border: '1px solid transparent',
            lineHeight: '24px',
            letterSpacing: '1px',
            transition: 'background-color 160ms ease, color 160ms ease',
            '& > :not(.MuiTouchRipple-root)': {
              position: 'relative',
              zIndex: 1,
            },
            '& .MuiTouchRipple-root': {
              color: COLORS.DARK_GRAY,
            },
            '&:hover': {
              color: COLORS.BLUE,
              backgroundColor: COLORS.WHITE,
              borderColor: COLORS.WHITE,
            },
            '&:active': {
              color: COLORS.BLUE,
              backgroundColor: COLORS.WHITE,
              borderColor: COLORS.WHITE,
            },
          }}
        >
          <Typography variant='button'>{t(isRegistered ? 'calc__text__demoFooterCabinetButton' : 'calc__text__demoRegisterButton')}</Typography>
        </Button>}
      </div>
    </Paper>
  )
}

export default Footer

